<script setup lang="ts">
const modalStore = useModalStore()
const { t } = useI18n()

const modalType = useState('newsletterModalType', () => 'success')
const registeredEmail = useState('newsletterEmail', () => '')

const isOpen = computed({
  get: () => modalStore.isNewsletterSuccessModal,
  set: (value) => {
    modalStore.isNewsletterSuccessModal = value
  }
})

const closeModal = () => {
  isOpen.value = false
}
</script>

<template>
  <VDialog
    v-model="isOpen"
    max-width="500"
    class="modal-newsletter-success"
  >
    <VCard class="modal-newsletter-success__card">
      <DialogCloseBtn
        variant="text"
        size="default"
        @click="closeModal"
      />
      
      <div class="modal-newsletter-success__content">
        <!-- Icon Wrapper -->
        <div class="modal-newsletter-success__icon-wrapper">
          
          <!-- Icon Success (Checkmark) -->
          <div v-if="modalType === 'success'" class="modal-newsletter-success__checkmark">
            <svg
              viewBox="0 0 52 52"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="26" cy="26" r="25" fill="none" stroke="currentColor" stroke-width="2" />
              <path
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- Icon Verify (Envelope) -->
          <div v-else class="modal-newsletter-success__envelope">
            <svg 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>

        </div>

        <!-- Title -->
        <h2 class="modal-newsletter-success__title">
          <template v-if="modalType === 'success'">
            {{ t('Subscription Successful!') }}
          </template>
          <template v-else>
            {{ t('Check Your Email') }}
          </template>
        </h2>

        <!-- Description -->
        <p class="modal-newsletter-success__description">
          <template v-if="modalType === 'success'">
            {{
              t(
                'Thank you for subscribing to our newsletter. You will receive the latest job opportunities in your inbox.'
              )
            }}
          </template>
          <template v-else>
            {{
              t(
                'We have sent a verification link to {email}. Please check your inbox to complete the subscription.',
                { email: registeredEmail }
              )
            }}
          </template>
        </p>

        <!-- Close Button -->
        <VBtn
          variant="flat"
          color="primary"
          size="large"
          class="text-none modal-newsletter-success__btn"
          @click="closeModal"
        >
          {{ t('Got it!') }}
        </VBtn>
      </div>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.modal-newsletter-success {
  &__card {
    padding: 32px 24px !important;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 24px;
  }

  &__icon-wrapper {
    margin: 20px 0;
  }

  &__checkmark {
    width: 80px;
    height: 80px;
    color: #16a04b;
    animation: slideIn 0.6s ease-out;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__envelope {
    width: 80px;
    height: 80px;
    color: #f63b3b;
    animation: slideIn 0.6s ease-out;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 600;
    color: #1e1e1e;
    margin: 0;
  }

  &__description {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }

  &__btn {
    min-width: 200px !important;
    margin-top: 12px;
  }
}

@keyframes slideIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
